import FormControl from "../../components/formControl";
import { Button } from "@material-ui/core";
import React from "react";
import CustomDropdown from "../../components/presentationals/CustomDropdown";
import config from "../../utils/config";
import { Skeleton } from "@mui/material";
import Spinner from "../../components/presentationals/Spinner";
import LoadingAutocomplete from "../../components/presentationals/LoadingAutocomplete";
import { NO_DATA_AVAILABLE } from "../../utils/constants";
import CustomTable from "../../components/customTable";
import CustomCard from "./components/CardCR";
import Alert from "../../components/alert";

const ClawbackReportView = ({
  searchFields,
  setSearchFields,
  onRunClick,
  partnerName,
  orgId,
  agentId,
  name,
  filterList,
  zdArdMardList,
  filteredArray,
  retailerList,
  rdsList,
  urlList,
  clawbackDetails,
  clawbackSummary,
  showClawbackSummary,
  loading,
  downloadCSV,
  timeStamp,
  showDownloadIcon,
  csvLoading,
  jcValue,
  setJcValue,
  distributorList,
  toggleShowDetails,
  hideAlertEd1,
  showAlert,
  showDateAlert,
  showErrorAlert,
  dispatch,
}) => {
  return (
    <>
      <Alert
        showAlert={showAlert}
        showDateAlert={showDateAlert}
        showError={showErrorAlert}
        message="Date Range should not be more than 30 days"
        hideAlert={() => dispatch(hideAlertEd1())}
      />
      <div className="container-fluid">
        <div className="whitebox mt-4 mb-1">
          <form autoComplete="off">
            {partnerName?.toLowerCase() === "nhq" ? (
              <FormControl
                variant="outlined"
                type="form"
                styleName="formControl"
              >
                <CustomDropdown
                  name={"Region"}
                  data={config.region}
                  changeHandler={(value) =>
                    setSearchFields((prev) => ({
                      ...prev,
                      region: value,
                      state:
                        config.states?.[
                          config.regionMaps[value?.toUpperCase()]
                        ]?.[0],
                    }))
                  }
                  value={searchFields?.region}
                />
              </FormControl>
            ) : null}
            {["nhq", "region head"].includes(partnerName?.toLowerCase()) ? (
              <FormControl
                variant="outlined"
                type="form"
                styleName="formControl"
              >
                <CustomDropdown
                  name={"State"}
                  data={
                    config.states?.[
                      config.regionMaps[searchFields?.region?.toUpperCase()]
                    ]
                  }
                  changeHandler={(value) => {
                    setSearchFields((prev) => ({ ...prev, state: value }));
                  }}
                  value={searchFields?.state}
                />
              </FormControl>
            ) : null}

            {["area"].includes(partnerName.toLowerCase()) ? (
              <FormControl
                variant="outlined"
                type="form"
                styleName="formControl"
              >
                <CustomDropdown
                  name={"JC"}
                  data={[]}
                  value={jcValue}
                  changeHandler={(val) => {
                    setJcValue(val);
                  }}
                />
              </FormControl>
            ) : null}

            {["nhq", "region head", "state head", "jc", "jpm", "area"].includes(
              partnerName?.toLowerCase()
            ) ? (
              <FormControl
                variant="outlined"
                type="form"
                styleName="formControl"
              >
                {filterList?.loading ? (
                  <LoadingAutocomplete
                    loading={filterList?.loading}
                    label={
                      partnerName?.toLowerCase() !== "jc"
                        ? "ZD/ARD/MARD"
                        : "RDS/ARD/MARD"
                    }
                  />
                ) : (
                  <CustomDropdown
                    loading={filterList?.loading}
                    name={
                      partnerName?.toLowerCase() !== "jc"
                        ? "ZD/ARD/MARD"
                        : "RDS/ARD/MARD"
                    }
                    data={
                      ["jc", "jpm", "area"].includes(partnerName?.toLowerCase())
                        ? filteredArray?.["RDS/ARD/MARD"]
                        : zdArdMardList
                    }
                    changeHandler={(value) => {
                      setSearchFields((prev) => ({
                        ...prev,
                        partner: value,
                        retailer: "ALL",
                        ...(partnerName?.toLowerCase() !== "jc" && {
                          RDS: "ALL",
                        }),
                      }));
                    }}
                    value={searchFields?.partner}
                  />
                )}
              </FormControl>
            ) : null}
            {searchFields?.partner?.includes("ZD") && (
              <FormControl
                variant="outlined"
                type="form"
                styleName="formControl"
              >
                <CustomDropdown
                  name={"RDS"}
                  data={rdsList}
                  changeHandler={(value) => {
                    setSearchFields((prev) => ({
                      ...prev,
                      RDS: value,
                      retailer: "ALL",
                    }));
                  }}
                  value={searchFields?.RDS}
                />
              </FormControl>
            )}
            {partnerName?.toLowerCase().includes("zonal") && (
              <FormControl
                variant="outlined"
                type="form"
                styleName="formControl"
              >
                {distributorList?.loading ? (
                  <LoadingAutocomplete
                    loading={distributorList?.loading}
                    label={"Distributors"}
                  />
                ) : (
                  <CustomDropdown
                    name={"Distributors"}
                    data={distributorList?.data?.content}
                    changeHandler={(value) => {
                      setSearchFields((prev) => ({
                        ...prev,
                        distributor: value,
                        retailer: "ALL",
                      }));
                    }}
                    value={searchFields?.distributor}
                  />
                )}
              </FormControl>
            )}
            {((!searchFields?.partner?.includes("ZD - ") ||
              searchFields?.RDS?.includes("RDS - ")) &&
              !partnerName?.toLowerCase().includes("zonal")) ||
            (partnerName?.toLowerCase().includes("zonal") &&
              searchFields?.distributor &&
              searchFields?.distributor !== "ALL") ? (
              <FormControl
                variant="outlined"
                type="form"
                styleName="formControl"
              >
                {retailerList?.loading ? (
                  <LoadingAutocomplete
                    loading={retailerList?.loading}
                    label={"Retailer"}
                  />
                ) : (
                  <CustomDropdown
                    name={"Retailer"}
                    data={retailerList?.data?.content || []}
                    changeHandler={(value) => {
                      setSearchFields((prev) => ({ ...prev, retailer: value }));
                    }}
                    value={searchFields?.retailer}
                  />
                )}
              </FormControl>
            ) : null}
            <FormControl variant="outlined" type="form" styleName="formControl">
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  onRunClick();
                }}
                variant="contained"
                color="default"
                disabled={false}
              >
                Run
              </Button>
            </FormControl>
          </form>
        </div>

        <h2
          className="pagetitle wow fadeInUp"
          data-wow-delay=".5s"
          data-wow-duration="0.7s"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "1rem",
          }}
        >
          <span style={{ flex: "1 1 auto", minWidth: "200px" }}>
            Partners Clawback Report
          </span>
          {showDownloadIcon &&
            (csvLoading?.loading ? (
              <Spinner size="small" />
            ) : (
              <button
                size="small"
                className="btn btn-primary wow fadeInUp"
                data-wow-delay=".5s"
                data-wow-duration="0.5s"
                onClick={() => downloadCSV(searchFields)}
                style={{
                  whiteSpace: "nowrap",
                  minWidth: "fit-content",
                }}
              >
                Download CSV
              </button>
            ))}
        </h2>
        <p
          className="text-muted mb-4 fw-bold"
          style={{
            fontSize: "16px",
            color: "#6c757d",
          }}
        >
          Note :{" " + window.CLAWBACK_NOTE}
        </p>

        {loading ? (
          <Spinner />
        ) : !clawbackSummary?.data &&
          !clawbackSummary?.loading &&
          !clawbackSummary?.error ? (
          <div
            className="whitebox wow fadeInUp text-center disclaimer p-4 rounded"
            data-wow-delay=".6s"
            data-wow-duration="0.7s"
          >
            <ul>
              <li>{window.CLICK_RUN_1}</li> <li>{window.CLICK_RUN_2}</li>
            </ul>
          </div>
        ) : (
          <div className="whitebox wow fadeInUp">
            {clawbackSummary?.loading ? (
              <Spinner />
            ) : clawbackSummary?.error ? (
              <div className="text-center text-danger">
                {clawbackSummary.error}
              </div>
            ) : clawbackSummary?.data &&
              Object.keys(clawbackSummary?.data)?.length > 0 ? (
              <>
                <div
                  className="d-flex flex-wrap w-100 justify-content-between align-items-stretch gap-3"
                  role="list"
                  aria-label="Summary cards"
                >
                  {Object.entries(clawbackSummary?.data)?.map(
                    ([key, value], ind) => (
                      <div
                        key={key}
                        role="listitem"
                        className="flex-grow-1 flex-basis-0"
                        style={{ minWidth: "250px" }}
                      >
                        <CustomCard
                          title={key}
                          value={value}
                          type={key?.toLowerCase()}
                        />
                      </div>
                    )
                  )}
                </div>
                {urlList?.details?.tileEndPointUrl && (
                  <div className="mt-4">
                    <span
                      className="cursor-pointer primary"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleShowDetails(searchFields);
                      }}
                      style={{
                        pointerEvents: clawbackDetails?.loading
                          ? "none"
                          : "auto",
                        opacity: clawbackDetails?.loading ? 0.6 : 1,
                      }}
                    >
                      {showClawbackSummary ? (
                        <div style={{ color: "#1e68fa", cursor: "pointer" }}>
                          Hide Details
                        </div>
                      ) : (
                        <div style={{ color: "#1e68fa", cursor: "pointer" }}>
                          Show Details
                        </div>
                      )}
                    </span>
                  </div>
                )}
              </>
            ) : (
              <div className="text-center">{NO_DATA_AVAILABLE}</div>
            )}
            {showClawbackSummary && (
              <div className="">
                {clawbackDetails?.loading ? (
                  <Spinner />
                ) : clawbackDetails?.error ? (
                  <div className="text-center text-danger">
                    {clawbackDetails?.error}
                  </div>
                ) : Array.isArray(clawbackDetails?.data) &&
                  clawbackDetails?.data?.length > 0 ? (
                  <CustomTable
                    data={clawbackDetails?.data}
                    columnAlignments={[
                      "left",
                      "left",
                      "left",
                      "right",
                      "right",
                      "right",
                    ]}
                  />
                ) : (
                  <div className="text-center mt-2 mb-2">
                    {NO_DATA_AVAILABLE}
                  </div>
                )}
              </div>
            )}

            {timeStamp?.loading ? (
              <div className="mt-2">
                <Skeleton variant="rectangular" width={"30%"} />
              </div>
            ) : timeStamp?.data ? (
              <div className="card-timestamp border-top mt-2">
                <i className="fa fa-history mr-2 mt-2 mb-0"></i>{" "}
                {`Updated on : ${timeStamp?.data}`}
              </div>
            ) : (
              <div className="text-center mt-4">{timeStamp?.error}</div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default ClawbackReportView;
